import { c as _c } from "react/compiler-runtime";
import React, { ReactNode, PropsWithChildren } from 'react';
import { usePopperTooltip, TriggerType } from 'react-popper-tooltip';
import type { Config } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import UAParser from 'ua-parser-js';
interface TooltipProps {
  tooltip: ReactNode;
  trigger?: TriggerType | TriggerType[] | null;
  placement?: Config['placement'];
  offset?: Config['offset'];
}
export const Tooltip = t0 => {
  const $ = _c(22);
  const {
    children,
    tooltip,
    trigger,
    placement,
    offset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const parser = new UAParser();
    t1 = parser.getOS();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isIOS = t1.name === "iOS";
  let t2;
  if ($[1] !== trigger) {
    t2 = trigger ?? isIOS ? ["click", "focus"] : ["hover", "click", "focus"];
    $[1] = trigger;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== offset || $[4] !== placement || $[5] !== t2) {
    t3 = {
      trigger: t2,
      placement,
      offset
    };
    $[3] = offset;
    $[4] = placement;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip(t3);
  let t4;
  if ($[7] !== tooltip) {
    t4 = <span className="sr-only">{tooltip}</span>;
    $[7] = tooltip;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== setTriggerRef || $[11] !== t4) {
    t5 = <span ref={setTriggerRef} className="flex items-center justify-center">{children}{t4}</span>;
    $[9] = children;
    $[10] = setTriggerRef;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== getArrowProps || $[14] !== getTooltipProps || $[15] !== setTooltipRef || $[16] !== tooltip || $[17] !== visible) {
    t6 = visible && <div ref={setTooltipRef} {...getTooltipProps({
      className: "tooltip-container text-white! p-4! rounded-2xl! w-64! border-0!"
    })}><div {...getArrowProps({
        className: "tooltip-arrow"
      })} />{tooltip}</div>;
    $[13] = getArrowProps;
    $[14] = getTooltipProps;
    $[15] = setTooltipRef;
    $[16] = tooltip;
    $[17] = visible;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};